import { Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  outcomeMessage: string;
  isLoading: boolean;

  handleOutcomeClick(chosenOutcome: string): () => void;
}

const CallTranscriptHeader: React.FC<Props> = ({ outcomeMessage, isLoading, handleOutcomeClick }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.statisticsHeader}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Typography className={classes.titleText}>{t('callTranscriptAndPersonalityProfile')}</Typography>
        {!outcomeMessage && !isLoading && (
          <Stack direction={'row'} gap={2}>
            <PaiButton text={t('meetingBooked')} size={'small'} border={'rounded'} action={handleOutcomeClick('meetingBooked')} />
            <PaiButton text={t('noMeetingBooked')} size={'small'} border={'rounded'} action={handleOutcomeClick('noMeeting')} />
            <PaiButton text={t('unsuccessful')} size={'small'} border={'rounded'} color={'error'} action={handleOutcomeClick('unsuccessful')} />
          </Stack>
        )}
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  statisticsHeader: {
    width: '100%',
    background: theme.palette.backgrounds.dark,
    padding: '16px 56px',
    position: 'sticky',
    top: -16,
    zIndex: 99,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(25),
    color: '#FFF',
  },
}));

export default CallTranscriptHeader;
